import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SingleQuestion = _resolveComponent("SingleQuestion")!

  return (_ctx.questionTable.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionTable, (row) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "row questions-row",
            key: row
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell) => {
              return (_openBlock(), _createBlock(_component_SingleQuestion, {
                key: cell,
                "left-value": cell.lhs,
                "right-value": cell.rhs,
                operation: cell.op.symbol,
                result: cell.result(),
                "random-question": _ctx.randomQuestion
              }, null, 8, ["left-value", "right-value", "operation", "result", "random-question"]))
            }), 128))
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}